import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import { Button } from '@mui/material';

const GOLD = '#d4af37';
const GOLD_SOFT = 'rgba(212,175,55,0.75)';
const GOLD_DIM = 'rgba(212,175,55,0.6)';
const TEXT_WARM = '#f9f6e3';
const BLACK = '#000';

function LogOutButton() {
    const handleLogout = () => {
        signOut(auth);
    };

    return (
        <Button
            variant="contained"
            onClick={handleLogout}
            size="medium"
            sx={{
                px: 2,
                py: 1,
                fontWeight: 700,
                textTransform: 'none',
                letterSpacing: 0.6,
                fontFamily: `'Cinzel', serif`,
                color: BLACK,
                background: `linear-gradient(180deg, ${GOLD} 0%, #c49b2a 100%)`,
                border: `1px solid ${GOLD_DIM}`,
                boxShadow: `0 4px 18px rgba(212,175,55,0.3)`,
                borderRadius: 2,
                '&:hover': {
                    background: `linear-gradient(180deg, #e2c35b 0%, ${GOLD} 100%)`,
                    boxShadow: `0 6px 22px rgba(212,175,55,0.45)`,
                },
                '&:active': {
                    transform: 'scale(0.98)',
                    boxShadow: `0 2px 10px rgba(212,175,55,0.25)`,
                },
            }}
        >
            Log Out
        </Button>
    );
}

export default LogOutButton;
